<template>
    <div class="row">
        <div class="col-lg-12">
            <ul class="nav nav-pills with-padding-bottom hidden-md-down profile-tabs" role="tablist">
            <li class="nav-item" v-for="(name, key) in tabs" :key="key">
                <a class="nav-link" data-toggle="tab" :href="linkToTab(key)" role="tab" :id="`link-${key}`">{{ name }}</a>
            </li>
        </ul>

            <!-- Smaller device tabs -->
            <ul class="nav nav-pills with-padding-bottom hidden-lg-up profile-tabs" role="tablist">
                <li class="nav-item dropdown">
                    <a class="nav-link active dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Change Tab: <span class="tab-name">Profile</span></a>
                    <div class="dropdown-menu">
                        <a class="dropdown-item" data-toggle="tab" v-for="(name, key) in tabs" :key="key" :href="linkToTab(key)" role="tab">{{ name }}</a>
                    </div>
                </li>
            </ul>

            <!-- Tab panes -->
            <div class="tab-content">
                <div class="tab-pane active" id="profile" role="tabpanel">
                    <client-edit :client.sync="localClient"
                                 :carriers="carriers"
                                 :create="create"
                                 :role="role"
                                 @continue="nextTab()"
                    />
                </div>
                <div class="tab-pane" id="addresses" role="tabpanel">
                    <client-addresses :client="localClient"
                                          :create="create"
                                          :role="role"
                                          v-if="unlocked"
                                          @continue="nextTab()"
                    />
                </div>
                <!-- <div class="tab-pane" id="poa" role="tabpanel">
                    <client-power-of-attorney :client="localClient"
                                              :create="create"
                                              v-if="unlocked"
                                              @continue="nextTab()"
                    />
                </div> -->
                <div class="tab-pane" id="phones" role="tabpanel">
                    <client-phone-numbers :client="localClient"
                                          :create="create"
                                          v-if="unlocked"
                                          :role="role"
                                          @continue="nextTab()"
                    />
                </div>
                <div class="tab-pane" id="caregivers" role="tabpanel">
                    <business-client-caregivers :client_id="localClient.id"
                                                :create="create"
                                                :role="role"
                                                v-if="unlocked"
                    />
                    <b-row v-if="create">
                        <b-col>
                            <b-btn variant="success" size="lg" @click="nextTab()">Save and Continue</b-btn>
                        </b-col>
                    </b-row>
                </div>
                <div class="tab-pane" id="call-logs" role="tabpanel">

                    <support-call-list :role="role" :client=" localClient " />
                </div>
                <div class="tab-pane" id="messages" role="tabpanel">

                    <business-message-list :role=" role " :client=" localClient " />
                </div>
                <div class="tab-pane" id="textthread" role="tabpanel">

                    <text-thread :role=" role " :userId=" localClient.id " />
                </div>
                <div class="tab-pane" id="documents" role="tabpanel">
                    <document-list
                            :initial-documents="[]"
                            :user-id="localClient.id"
                            :create="create"
                            :role=" role "
                            v-if="unlocked"
                    />
                    <b-row v-if="create">
                        <b-col>
                            <b-btn variant="success" size="lg" @click="nextTab()">Save and Continue</b-btn>
                        </b-col>
                    </b-row>
                </div>
                <div class="tab-pane" id="manage" role="tabpanel">
                    <client-manage :client="localClient"
                        :create="create"
                        v-if="unlocked"
                        :role="role"
                        @continue="nextTab()"
                        :user="user"
                    />
                </div>
                <div class="tab-pane" id="invoices" role="tabpanel">

                    <submitted-invoices-report :carrier_preselect=" localClient.ltc_carrier_id " :role=" role " :client=" localClient "></submitted-invoices-report>
                </div>
                <div class="tab-pane" id="visits" role="tabpanel">

                    <business-shift-report :role=" role " :client=" localClient "></business-shift-report>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import EnrollmentStatuses from "../../../mixins/EnrollmentStatuses";
    import FormatsDates from "../../../mixins/FormatsDates";
    import ClientManage from "./ClientManage";
    import ClientAuditLogs from "./ClientAuditLogs";
    import UsesRole from "../../../mixins/UsesRole";

    export default {

        name       : "BusinessClient",
        components : { ClientAuditLogs, ClientManage },
        mixins     : [ EnrollmentStatuses, FormatsDates, UsesRole ],

        props: {

            client: {

                type: Object,
                default() {
                    return { id: 0 }
                }
            },
            create: Boolean,
            carriers: {

                type: Array,
                default: () => { return []; },
            },
            user: {}
        },

        data() {

            return {

                activeTab   : 'profile',
                localClient : this.client,
            }
        },

        computed: {
            hasEmail() {
                return !! this.client.email;
            },

            enrolled() {
                return this.isEnrolled(this.client.enrollment_status);
            },

            unlocked() {
                return this.localClient.id > 0;
            },

            activeTabIndex() {
                return Object.keys(this.tabs).findIndex(item => { return item === this.activeTab; });
            },
            
            tabs() {
              var tabs = {
                'profile': 'Profile',
                    'addresses': 'Addresses',
                    'phones': 'Phone Numbers',
                    'caregivers': 'Independent Providers',
                    'call-logs': 'Call Logs',
                    'documents': 'Documents',
                    'messages': 'Messages',
                    'textthread': 'Text Thread',
                    'manage': 'Manage',
                    'invoices': 'Invoices',
                    'visits': 'Visits'
              };
              if (this.role === 'carrier_manager') {
                 tabs = {
                  'profile': 'Profile',
                  'addresses': 'Addresses',
                  'phones': 'Phone Numbers',
                  'caregivers': 'Independent Providers',
                  'call-logs': 'Call Logs',
                  'documents': 'Documents',
                  'textthread': 'Text Thread',
                  'manage': 'Manage',
                  'invoices': 'Invoices',
                  'visits': 'Visits'
                }
              }
                if (!this.localClient.active && this.create !== true) {
                    delete tabs.documents;
                }

                return tabs;
            },
        },

        methods: {
            async sendTiff() {
                if (confirm('Are you sure you wish to submit the deactivation notice?')) {
                    let form = new Form({});
                    await form.post(`/${this.controller}/${this.claimantModel}/${this.localClient.id}/decommission_notice/submit`);
                }
            },

            linkToTab(tab) {
                return '#' + tab;
            },

            nextTab() {
                let keys = Object.keys(this.tabs);
                if (this.activeTabIndex > keys.length-1) {
                    this.activeTab = keys[0];
                }
                this.activeTab = keys[this.activeTabIndex + 1];
            },

            updateTabClasses()
            {
                if (this.unlocked) {
                    $(".profile-tabs a[data-toggle=tab]").removeClass('disabled');
                    return;
                }
                $(".profile-tabs a[data-toggle=tab]:not(:first)").addClass('disabled');
            },
        },

        mounted() {
            const component = this;

            // Update tab classes
            $(".profile-tabs a[data-toggle=tab]:first").addClass('active');
            this.updateTabClasses();

            $(".profile-tabs a[data-toggle=tab]").on("click", function(e) {
                if (!component.unlocked) {
                    e.preventDefault();
                    alert('Use the "Continue" button once finished entering profile details.');
                    return false;
                }

                // fixes tab hide bug when clicking twice
                let targetHref = e.currentTarget.href;
                let tab = targetHref.split('#')[1];
                if(tab === component.activeTab) {
                    e.preventDefault();
                    return false;
                }

                var $link = $(this);

                //remove active class from other tab-panes
                $('.tab-content:not(.' + $link.attr('href').replace('#','') + ') .tab-pane').removeClass('active');

                // activate tab-pane for active section
                $('.tab-content.' + $link.attr('href').replace('#','') + ' .tab-pane:first').addClass('active');
            });

            // Javascript to enable link to tab
            var url = document.location.toString();
            if (url.match('#')) {
                let tab = url.split('#')[1];
                $('.profile-tabs .nav-item a[href="#' +
                    tab + '"]').tab('show');
                component.activeTab = tab;
            }

            // Change hash for page-reload
            $('.profile-tabs .nav-item a').on('shown.bs.tab', function (e) {
                window.location.hash = e.target.hash;
                component.activeTab = e.target.hash.split('#')[1];
                window.scrollTo(0,0);
            })
        },

        watch: {
            unlocked() {
                this.updateTabClasses();
            },

            activeTab(val) {
                $('#link-' + val).tab('show');
            },
        }
    }
</script>
